import script from "./GoodiesWinners.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodiesWinners.vue?vue&type=script&setup=true&lang=js"

import "./GoodiesWinners.vue?vue&type=style&index=0&id=f48a5ace&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f48a5ace"]])

export default __exports__